<template>
	<header component="Header">
		<h1>{{ routeName }}</h1>
	</header>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
	name: 'Header',

	setup() {
		const route = useRoute();
		const routeName = computed(() => route.meta.title);

		return { routeName };
	},

	data: () => ({}),

	computed: {},

	methods: {}
});
</script>

<style lang="scss" scoped>
[component="Header"] {
	grid-area: header;
	display: flex;
	align-items: center;
	box-shadow: 0 15px 30px -25px rgba(0, 0, 0, .4);
	padding: 0 20px;
	background: var(--p-surface-0);
	z-index: 10;
	height: 60px;

	h1 {
		font-weight: 600;
	}
}
</style>